import { render, staticRenderFns } from "./gp-section.vue?vue&type=template&id=e3fb269c"
import script from "./gp-section.vue?vue&type=script&lang=js"
export * from "./gp-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports